import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectLocale } from '@app/redux';

export const useIsActiveRoute = (route: string) => {
  const {
    locale: { urlPrefix },
  } = useSelector(selectLocale);
  const location = useLocation();

  const currentLocation = location.pathname;
  if (route === '/' || route === urlPrefix || route === `${urlPrefix}/` || route === '/SignContract') {
    return (
      currentLocation === '/' ||
      currentLocation === urlPrefix ||
      currentLocation === `${urlPrefix}/` ||
      currentLocation === '/SignContract'
    );
  }

  return currentLocation.includes(route);
};
